// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getMerchant, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getName as getMerchantName } from '@tectonics/prs/merchant';
import { shouldRedirect } from '@tectonics/prs/incoming-payment/should-redirect';

export function Header(): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  const merchantName = getMerchantName(merchant);
  const pageIsBeingRedirected = shouldRedirect(incomingPayment);

  return (
    <Root>
      {pageIsBeingRedirected ? (
        <PaymentConfirmedMessage>
          Você esta sendo redirecionado para {merchantName}
        </PaymentConfirmedMessage>
      ) : (
        <>
          <PaymentConfirmedMessage>
            Este pagamento já foi concluído
          </PaymentConfirmedMessage>
          <PaymentConfirmedInfo>
            Se você quiser saber mais detalhes sobre
            esse pagamento, acesse o site onde a compra foi feita.
          </PaymentConfirmedInfo>
        </>
      )}
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  line-height: 1.5;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
`;

const PaymentConfirmedMessage = styled.div`
  font-size: 25px;
  margin: 15px 0;
  font-weight: 200;
  color: ${props => props.theme.colors.black[0]};
`;

const PaymentConfirmedInfo = styled.div`
  font-size: 14px;
  font-weight: 300;
`;
